// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"dab16646","368":"12092e3d","406":"fef6afdd","420":"77a03945","509":"f811d670","557":"b9fe4fdc","562":"58b7cc52","633":"b3cebff3","715":"1d846e0e","729":"44ac5bad","774":"c2ae1fcc","973":"df52925d","984":"44560b39"}[chunkId] + ".chunk.js";
};